/**
 * @generated SignedSource<<90e97a947949ae9d26bd51e09ead3055>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SendInvoiceInput = {
  id: string;
};
export type SendInvoiceDialogMutation$variables = {
  input: SendInvoiceInput;
};
export type SendInvoiceDialogMutation$data = {
  readonly sendInvoice: {
    readonly id: string;
    readonly updatedAt: any | null | undefined;
  };
};
export type SendInvoiceDialogMutation = {
  response: SendInvoiceDialogMutation$data;
  variables: SendInvoiceDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Invoice",
    "kind": "LinkedField",
    "name": "sendInvoice",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SendInvoiceDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SendInvoiceDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "25557dbfea89540d1672fe7bb331846c",
    "id": null,
    "metadata": {},
    "name": "SendInvoiceDialogMutation",
    "operationKind": "mutation",
    "text": "mutation SendInvoiceDialogMutation(\n  $input: SendInvoiceInput!\n) {\n  sendInvoice(input: $input) {\n    id\n    updatedAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "f5a6987171f5c4ca3f566d08f2201a2a";

export default node;
